import isEmpty from "lodash/isEmpty";
import keys from "lodash/keys";
import { useFiltersV2Actions } from "PFApp/components/filters_v2";
import { FiltersV2List } from "PFApp/components/filters_v2/parts/filters_v2_list";
import { Accordion } from "PFComponents/accordion";
import {
  areFiltersModified,
  areNonRequiredFilterValuesEmpty,
  hasAnyDefaultValue
} from "PFCore/helpers/filters";
import { FilterKeyV2, FiltersV2 } from "PFTypes/filters_v2";

import commonCss from "../side_filters.module.scss";
import { AccordionHeader, AccordionHeaderProps } from "./accordion_header";

type ActivitySidePanelFiltersProps = {
  filters: FiltersV2;
} & Omit<AccordionHeaderProps, "onClear" | "onRestore">;

export const ActivityPageFilters = ({ filters, ...accordionHeaderProps }: ActivitySidePanelFiltersProps) => {
  const { clearBufferValues, resetBufferValues } = useFiltersV2Actions();

  const canClear = !areNonRequiredFilterValuesEmpty(filters);
  const canRestore = areFiltersModified(filters) && hasAnyDefaultValue(filters);

  const handleClear = (event) => {
    event.stopPropagation();
    clearBufferValues({ subset: keys(filters) as FilterKeyV2[] });
  };

  const handleRestore = (event) => {
    event.stopPropagation();
    resetBufferValues({ subset: keys(filters) as FilterKeyV2[] });
  };

  if (isEmpty(filters)) {
    return null;
  }

  return (
    <section className={commonCss.section}>
      <Accordion
        header={
          <AccordionHeader
            onClear={canClear && handleClear}
            onRestore={canRestore && handleRestore}
            {...accordionHeaderProps}
          />
        }
        headerVariant="bodyBold"
        headerFullWidth
        iconSet="chevron"
      >
        <FiltersV2List narrow vertical filters={filters} />
      </Accordion>
    </section>
  );
};
